import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import ImageWithFallback from 'components/ImageWithFallback';
import { useDrawStore } from 'hooks/stores/useDrawStore';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import { HOMEPAGE_BUCKET_LINK } from 'utils/image/bucketLinks';
import { EnterButton } from '../enter-button/EnterButton';
import { HomePageHowItWorksVideo } from './HomePageHowItWorksVideo';
import styles from './HowItWorksSection.module.css';
import { PLAYER_FIRST_NAME_ALT_FALLBACK } from 'components/referrals/2026/ReferralConstants';
import { AvatarOnRubberRing } from 'components/referrals/2026/AvatarOnRubberRing';
import BeachTopRight from '../../../components/svg/refer-a-friend/BeachTopRight.svg';

interface Props {
  isSubscriber: boolean;
  referrerFirstName?: string;
  referrerAvatarLocation?: string;
}

export const HowItWorksSection = observer((props: Props) => {
  const { treesPlantedCount } = useDrawStore();

  return (
    <AboutUsModule background={'tealGradient'}>
      <AboutUsSiteContainer>
        <div className={styles.container}>
          <h2 className={`aboutUsTypographyHeaderXlargeOnTeal`}>
            How it works
          </h2>
          <div className={styles.howItWorksSection}>
            <div className={styles.howItWorksVideoContainer}>
              <HomePageHowItWorksVideo />
            </div>

            <div className={styles.howItWorksContent}>
              <div className={styles.howItWorksSteps}>
                <div className={styles.howItWorksStep}>
                  <p className={`${styles.howItWorksHeading} noMargin`}>
                    <span className={styles.howItWorksImageContainer}>
                      <ImageWithFallback
                        src={{
                          src: `${HOMEPAGE_BUCKET_LINK}/choose-numbers.webp`,
                          width: 22,
                          height: 30,
                        }}
                        alt="choose your numbers"
                      />
                    </span>
                    <strong>Choose numbers</strong>
                  </p>
                  <p className="noMargin aboutUsTypographyBodySmall">
                    {props.referrerFirstName != undefined ? (
                      <>
                        Sign up with <strong>50% off your 1st month</strong> and
                        then select 5 lucky numbers
                      </>
                    ) : (
                      'Choose from our paid or free entry options and then select 5 lucky numbers'
                    )}
                  </p>
                </div>
                <div className={styles.howItWorksStep}>
                  <p className={`${styles.howItWorksHeading} noMargin`}>
                    <span className={styles.howItWorksImageContainer}>
                      <ImageWithFallback
                        src={{
                          src: `${HOMEPAGE_BUCKET_LINK}/match-to-win.webp`,
                          width: 24,
                          height: 24,
                        }}
                        alt="match to win"
                      />
                    </span>
                    <strong>Match to win</strong>
                  </p>
                  <p className="noMargin aboutUsTypographyBodySmall">
                    The winning numbers will be randomly drawn every Tuesday &
                    Friday at 5pm
                  </p>
                </div>

                <div className={styles.howItWorksStep}>
                  <p className={`${styles.howItWorksHeading} noMargin`}>
                    <span className={styles.howItWorksImageContainer}>
                      <ImageWithFallback
                        src={{
                          src: `${HOMEPAGE_BUCKET_LINK}/choose-your-prize.webp`,
                          width: 24,
                          height: 22,
                        }}
                        alt="choose your prize"
                      />
                    </span>
                    <strong>Choose your prize</strong>
                  </p>
                  <p className="noMargin aboutUsTypographyBodySmall">
                    The more numbers you match, the bigger the prize you can
                    choose – over 400 epic prizes on offer
                  </p>
                </div>

                <div className={styles.howItWorksStep}>
                  <p className={`${styles.howItWorksHeading} noMargin`}>
                    <span className={styles.howItWorksImageContainer}>
                      <ImageWithFallback
                        src={{
                          src: `${HOMEPAGE_BUCKET_LINK}/1-purchase-1-tree.webp`,
                          width: 24,
                          height: 24,
                        }}
                        alt="1 purchase = 1 tree"
                      />
                    </span>
                    <strong>1 purchase = 1 tree</strong>
                  </p>
                  <p className="noMargin aboutUsTypographyBodySmall">
                    {treesPlantedCount?.toLocaleString('en-GB')} trees planted
                    so far by our players with veritree
                  </p>
                </div>
              </div>
              {props.referrerFirstName != undefined && (
                <div className={styles.referrerContainer}>
                  <BeachTopRight className={styles.referrerBackgroundImage} />
                  <div className={styles.referrerImage}>
                    <AvatarOnRubberRing
                      avatarUrl={props.referrerAvatarLocation}
                    />
                  </div>
                  <div
                    className={styles.referrerTextContainer + ' withNoSpacing'}
                  >
                    <h3 className="aboutUsTypographyHeaderMedium textAlignLeft">
                      Win with{' '}
                      {props.referrerFirstName ||
                        PLAYER_FIRST_NAME_ALT_FALLBACK}
                    </h3>
                    <p
                      className={
                        'aboutUsTypographyBodySmall ' + styles.offerText
                      }
                    >
                      Because{' '}
                      {props.referrerFirstName ||
                        PLAYER_FIRST_NAME_ALT_FALLBACK}{' '}
                      invited you, you’ll get <strong>50% off</strong> your
                      first month and win <strong>up to £5,000</strong> whenever
                      they win a prize in our weekly draw!
                    </p>
                  </div>
                </div>
              )}
              {!props.isSubscriber && <EnterButton />}
            </div>
          </div>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
});
